<template>
  <div class="company-contact-list pb-3">

    <b-row
        class="my-3 pb-1 d-flex flex-column flex-sm-row flex-wrap justify-content-center justify-content-sm-between align-items-center">
      <b-col cols="12" sm="5">
        <h3 class="mb-0">Company Contacts
          <helper :tag="helpTag"/>
        </h3>
      </b-col>
    </b-row>

    <b-table ref="table"
             :fields="fields"
             :items="modelInstance.companyContacts"
             striped>
      <template v-slot:cell()="row">
        <div v-if="['first_name','last_name','email','phone_mobile','phone_office'].includes(row.field.key)">
          <template v-if="editObject && editObject.id === row.item.id">
            <b-form-input v-model="editObject[row.field.key]"
                          type="text"/>
          </template>

          <template v-else>
            {{ row.item[row.field.key] }}
          </template>
        </div>

        <div v-else-if="row.field.key === 'actions' && !readOnly" class="action-buttons d-flex">
          <template v-if="!editObject">
            <b-button
                class="btn-icon ml-2" size="sm" variant="secondary"
                @click="edit(row.item)">
              <b-icon-pencil-square/>
            </b-button>
            <b-button
                class="btn-icon ml-2" size="sm" variant="danger"
                @click="remove(row.item)">
              <b-icon-trash/>
            </b-button>
          </template>

          <template v-else-if="editObject.id === row.item.id">
            <b-button class="float-right mt-1 ml-1" size="sm" variant="primary" @click="save(row.item)">
              <b-icon-check2/>
            </b-button>
            <b-button class="float-right mt-1 ml-1" size="sm" variant="danger" @click="cancel()">
              <b-icon-x/>
            </b-button>
          </template>
        </div>
      </template>
    </b-table>

    <div v-if="!readOnly" class="text-right mt-3">
      <b-button
          class="mr-3"
          variant="primary"
          @click="create()">
        Add Company Contact
        <b-icon-plus-square/>
      </b-button>
    </div>

  </div>
</template>

<script>
import Authorization from '@/providers/Authorization'
import Helper from "./Helper.vue";
import * as _ from 'lodash'

export default {
  name: 'CompanyContactList',
  components: {Helper},
  props: {
    companyId: Number,
    readOnly: {
      type: Boolean,
      default: true
    },
    helpTag: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modelInstance: Object,
      fields: [
        {key: 'first_name', sortable: false, label: 'First Name'},
        {key: 'last_name', sortable: false, label: 'Last Name'},
        {key: 'email', sortable: false, label: 'Email'},
        {key: 'phone_mobile', sortable: false, label: 'Mobile Phone'},
        {key: 'phone_office', sortable: false, label: 'Office Phone'},
        {key: 'actions', sortable: false, label: 'Actions'},
      ],
      editObject: null
    }
  },
  methods: {
    edit(item) {
      this.editObject = _.cloneDeep(item)
    },
    cancel() {
      this.editObject = null
    },
    async save(item) {
      if (await this.$api.getItem(this, 'company-contact', item.id)) {
        if (await Authorization.can({action: 'edit', model: 'company', arg: this.companyId})) {
          return this.$api.updateItem(this, 'company-contact', this.editObject)
              .then(() => {
                this.editObject = null
                this.refresh()
              })
              .catch(() => this.$toasted.error(`Unable to update company contact`))
        } else {
          this.$toasted.error('Authorization error for updating company contact')
        }
      }
    },
    remove(item) {
      if (Authorization.can({action: 'edit', model: 'company', arg: this.companyId})) {
        if (confirm('Would you like to delete this company contact? This action cannot be undone.')) {
          this.$api.deleteItem(this, 'company-contact', item)
              .then(this.refresh)
              .catch(() => this.$toasted.error('Unable to delete company contact'))
        }
      } else {
        this.$toasted.error('Authorization error for deleting company contact')
      }
    },
    create() {
      if (Authorization.can({action: 'edit', model: 'company', arg: this.companyId})) {
        this.$api.createItem(this, 'company-contact', {company_id: this.companyId})
            .then(contact => {
              this.refresh()
              this.edit(contact.body)
            })
            .catch(() => this.$toasted.error('Unable to create company contact'))
      }
    },
    refresh() {
      this.$api.getItem(this, 'company', this.companyId, ['companyContacts'])
          .then(item => this.modelInstance = item)
    }
  },
  mounted() {
    this.refresh()
  }
}
</script>

<style lang="scss">
</style>
